/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the platform-browser-dynamic package.
 */

import {Version} from '@angular/core';

/**
 * @publicApi
 */
export const VERSION = /* @__PURE__ */ new Version('20.3.24');
